interface ProductLogoProps {
    className?: string;
    showAdminBadge?: boolean;
}

export function ProductLogo({ className, showAdminBadge = true }: ProductLogoProps) {
    return (
        <div className={className}>
            <img
                src="/assets/ai_korektury_logo.svg"
                alt="AI Korektury"
                className="h-9 w-auto"
            />
            {showAdminBadge && (
                <div className="mt-1 text-[10px] font-semibold uppercase tracking-wider text-muted-foreground">
                    Admin
                </div>
            )}
        </div>
    );
}
